import { render, staticRenderFns } from "./AdminAccountTabPrivs.vue?vue&type=template&id=8873c6b2&scoped=true"
import script from "./AdminAccountTabPrivs.vue?vue&type=script&lang=js"
export * from "./AdminAccountTabPrivs.vue?vue&type=script&lang=js"
import style0 from "./AdminAccountTabPrivs.vue?vue&type=style&index=0&id=8873c6b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8873c6b2",
  null
  
)

export default component.exports